export default "__VITE_ASSET__Co3i0Ynj__"